import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Button } from 'devextreme-react';
import { Popover } from 'devextreme-react/popover';
import notify from 'devextreme/ui/notify';
import { TextBox } from 'devextreme-react';
import { Link } from 'react-router-dom';
import "./header.css";

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginText: '',
            passwordText: '',
            userDetailVisible: false,
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            passwordVisible: false,
            newPasswordVisible: false,
            confirmPasswordVisible: false,
            changePasswordVisible: false,
            newPasswordDisabled: false
        };

        this.onLogoutClick = this.onLogoutClick.bind(this);
        this.showUserDetail = this.showUserDetail.bind(this);
        this.hideUserDetail = this.hideUserDetail.bind(this);

        this.onPassChangeConfirm = this.onPassChangeConfirm.bind(this);
        this.onOldPasswordChanged = this.onOldPasswordChanged.bind(this);
        this.onNewPasswordChanged = this.onNewPasswordChanged.bind(this);
        this.onConfirmPasswordChanged = this.onConfirmPasswordChanged.bind(this);
        this.onChangePassClick = this.onChangePassClick.bind(this);
        this.showChangePass = this.showChangePass.bind(this);

        this.refreshVisibleChangePasswordForManager = this.refreshVisibleChangePasswordForManager.bind(this);
    }

    componentDidMount() {
        this.refreshVisibleChangePasswordForManager();
    }

    refreshVisibleChangePasswordForManager() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);
        fetch('api/main/GetVisibleChangePasswordForManager', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ newPasswordDisabled: data });
            });
    }

    showUserDetail() {
        this.setState({
            userDetailVisible: true
        });
    }

    hideUserDetail() {
        this.setState({
            userDetailVisible: false
        });
    }    

    showChangePass(value) {
        this.setState({
            passwordVisible: value,
            newPasswordVisible: value,
            confirmPasswordVisible: value,
            changePasswordVisible: value,
            newPasswordDisabled: value
        });
    }

    onChangePassClick(e) {
        this.showChangePass(true);
    }

    onPassChangeConfirm(e) {
        var tokenKey = "accessToken";

        var passwordData = {
            oldPassword: this.state.oldPassword,
            newPassword: this.state.newPassword,
            confirmPassword: this.state.confirmPassword
        }

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/ChangePassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(passwordData)
        })
            .then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.showChangePass(false);
                this.hideUserDetail();
            });
    }

    onOldPasswordChanged(e) {
        this.setState({ oldPassword: e.value });
    }

    onNewPasswordChanged(e) {
        this.setState({ newPassword: e.value });
    }

    onConfirmPasswordChanged(e) {
        this.setState({ confirmPassword: e.value });
    }

    render() {
        return (
            <Grid fluid>
                <Row id="mainHeader">
                    <Col lg={12}>
                        <a href="/summary"><img width="50" height="50" src="../assets/lockoinvest_sign_background.png" /></a>                                                    
                        <div className="userName">
                            <table>
                                <tr>
                                    <td>
                                        <div className="headerInfo"><a className="headerLink" href="mailto:clients@astra-am.ru">clients@astra-am.ru</a></div>
                                    </td>
                                    <td>
                                        <span className="userIcon dx-icon-user"></span>
                                    </td>
                                    <td>
                                        <div><div onClick={this.showUserDetail} id="userName" className="whiteLink">{sessionStorage.getItem("userName")}</div>
                                            <Popover
                                                target={'#userName'}
                                                position={'bottom'}
                                                width={300}
                                                visible={this.state.userDetailVisible}
                                                onHiding={this.hideUserDetail}
                                                shading={false}
                                            >
                                                <Grid fluid>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <Button className="userInfoItem" id="changePasswordButton"
                                                                text={'Изменить пароль'}
                                                                type={'default'}
                                                                width={200}
                                                                onClick={this.onChangePassClick}
                                                                disabled={this.state.newPasswordDisabled}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <TextBox value={this.state.passwordText} mode={'password'} className="userInfoItem marginTop"
                                                                onValueChanged={this.onOldPasswordChanged} visible={this.state.passwordVisible}
                                                                placeholder={'Старый пароль'} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <TextBox value={this.state.passwordText} mode={'password'} className="userInfoItem marginTop"
                                                                onValueChanged={this.onNewPasswordChanged} visible={this.state.newPasswordVisible}
                                                                placeholder={'Новый пароль'} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <TextBox value={this.state.passwordText} mode={'password'} className="userInfoItem marginTop"
                                                                onValueChanged={this.onConfirmPasswordChanged} visible={this.state.confirmPasswordVisible}
                                                                placeholder={'Подтверждение'} />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <Button
                                                                text={'Подтвердить'}
                                                                type={'default'}
                                                                width={200}
                                                                className="userInfoItem marginTop" id="acceptPasswordButton"
                                                                visible={this.state.changePasswordVisible}
                                                                onClick={this.onPassChangeConfirm}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <Button className="userInfoItem marginTop" id="logoutButton"
                                                                text={'Выйти'}
                                                                type={'default'}
                                                                width={200}
                                                                onClick={this.onLogoutClick}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Grid>
                                            </Popover>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    onLogoutClick() {
        var tokenKey = "accessToken";
        sessionStorage.removeItem(tokenKey);
        window.location.reload(false);
        window.location.href = '/';
    }
};


// WEBPACK FOOTER //
// ./App/containers/header/header.jsx